import { Button } from '@eg/elements/Button';
import { Modal } from '@eg/elements/Modal';
import { CheckColorIcon } from '@eg/elements/components/Icons/CheckColorIcon';
import { TooltipIcon } from '@eg/elements/components/TooltipIcon';
import * as React from 'react';
import AemFragment from '../../../../components/AemFragment/AemFragment';
import Price from '../../../../components/Price/Price';
import { PriceSize } from '../../../../components/Price/Price.types';
import { aemAssets } from '../../../../configuration/serviceConfiguration';
import { PaymentMethodText } from '../../../../helpers/PaymentMethod';
import { yearFormatter } from '../../../../helpers/formattingHelper';
import {
  getBruttoBeitragForVariant,
  getNettoBeitragForVariant,
} from '../../../../helpers/variant.utils';
import { TrackingElementFeePage } from '../../../../tracking/tracking.types';
import { AemFragmentCatalog } from '../../../../types/AemFragmentCatalog';
import { RadioTabContentBenefitProps } from '../RadioTab.types';

const RadioTabBenefit = (props: RadioTabContentBenefitProps) => {
  const checkIconHeight = 24;
  const checkIconWidth = 24;
  const [showFragmentCatalogModal, setShowFragmentCatalogModal] = React.useState(false);
  const [showMoreInfoModal, setShowMoreInfoModal] = React.useState(false);
  const period = props.periodInYears && yearFormatter(props.periodInYears);

  const variante = props.varianten?.filter(variant => variant.variante === props.variant)[0];
  const nettobeitrag = getNettoBeitragForVariant(variante);
  const bruttobeitrag = getBruttoBeitragForVariant(variante);

  return (
    <div className="tab-content-body">
      <div className="tab-benefit-list">
        {props.benefitsData.map(benefit => (
          <li key={benefit.title}>
            <div>
              <CheckColorIcon height={checkIconHeight} width={checkIconWidth} />
              <span className="tab-benefit-text">{benefit.title}</span>
              <TooltipIcon
                isModal
                className="tab-benefit-list-tooltip-icon"
                onToggledOpen={isOpen => {
                  if (isOpen && benefit.trackingElement) {
                    props.trackClick(benefit.trackingElement);
                  }
                }}
              >
                {benefit.tooltip}
              </TooltipIcon>
            </div>
          </li>
        ))}
      </div>

      {aemAssets && aemAssets[AemFragmentCatalog.PRODUCT_TABLE] && (
        <>
          <Button
            variant="secondary"
            className="overview-button"
            onClick={() => {
              setShowFragmentCatalogModal(true);
              props.trackClick(TrackingElementFeePage.BUTTON_ALL_BENEFITS);
            }}
          >
            Alle Leistungen im Vergleich
          </Button>
          <Button
            variant="text-link"
            className="tab-content-moreInfo-btn"
            onClick={() => {
              setShowMoreInfoModal(true);
              props.trackClick(TrackingElementFeePage.BUTTON_MORE_INFO);
            }}
          >
            Mehr Infos zum Beitrag
          </Button>
          <Modal
            open={showFragmentCatalogModal}
            dismissible
            onDismiss={() => setShowFragmentCatalogModal(false)}
            backdropDismissesModal
            extendedWidth
          >
            <AemFragment name={AemFragmentCatalog.PRODUCT_TABLE} />
          </Modal>
        </>
      )}
      {showMoreInfoModal && (
        <Modal
          open={showMoreInfoModal}
          dismissible
          onDismiss={() => setShowMoreInfoModal(false)}
          backdropDismissesModal
          extendedWidth
        >
          <section className="esc_generated-content">
            <h5>Informationen zu Ihrem Beitrag</h5>
            {props.securityPlusValue?.insuranceSettingValue === false && (
              <>
                <h5>Ihr aktueller Beitrag ist für das erste Versicherungsjahr garantiert.</h5>
                <p>
                  {'Der aktuelle Beitrag von '}
                  <b>
                    <Price amount={String(nettobeitrag)} size={PriceSize.Small} unstyled />
                  </b>
                  <span>{` ${props.paymentMethod && PaymentMethodText[props.paymentMethod]}`}</span>
                  {
                    ' ist für das erste Versicherungsjahr garantiert (sog. Nettobeitrag). Während der Vertragslaufzeit kann Ihr Zahlbeitrag jedoch bis auf den maximalen Beitrag von '
                  }
                  <Price amount={String(bruttobeitrag)} size={PriceSize.Small} unstyled />
                  <span> {props.paymentMethod && PaymentMethodText[props.paymentMethod]}</span>
                  {' ansteigen (sog. Bruttobeitrag).'}
                </p>

                <p>
                  <b>Warum kann der Beitrag steigen?</b>
                  <br />
                  ERGO beteiligt Sie mit einem Sofort-Rabatt (sog. Beitragsvorwegabzug) an
                  Überschüssen aus der Kalkulation. Diese Überschüsse werden jährlich neu ermittelt.
                  Der Beitrag gilt, solange die Überschüsse unverändert bleiben.
                </p>
                <p>
                  Auf den folgenden Seiten wird deshalb jeweils Ihr <b>aktueller Beitrag</b>{' '}
                  angegeben und nicht der maximale Beitrag.
                </p>
                <p>
                  <b>
                    Tipp „Sicherheit Plus“: Mit dem optionalen Baustein „Sicherheit Plus“ bleibt Ihr
                    Beitrag über die gesamte Vertragslaufzeit garantiert gleich.
                  </b>
                </p>
              </>
            )}
            {props.securityPlusValue?.insuranceSettingValue === true && (
              <p>
                Sie haben den Baustein „Sicherheit Plus“ gewählt. Deshalb ist Ihr Beitrag von{' '}
                <b>
                  <Price amount={String(nettobeitrag)} size={PriceSize.Small} unstyled />
                </b>
                <span>
                  {` ${
                    props.paymentMethod && PaymentMethodText[props.paymentMethod]
                  } für die gesamte
                  Laufzeit garantiert.`}
                </span>
              </p>
            )}
          </section>
        </Modal>
      )}
    </div>
  );
};

export default RadioTabBenefit;
